import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { addDays, format, startOfToday } from 'date-fns';
import { Observable, map, of } from 'rxjs';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';
import { DateService } from 'src/app/services/date.service';

@Component({
  selector: 'app-select-date-question',
  templateUrl: './select-date-question.component.html',
  styleUrls: ['./select-date-question.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class SelectDateQuestionComponent implements OnInit {

  @Input() question: QQQuestionViewModel;
  @Input() showHeader: boolean = false;

  options$ = new Observable<Options[]>();

  constructor(
    private dateService: DateService
  ) { }

  ngOnInit() {
    if (!this.question.editingValue)
      this.question.editingValue = "";
    this.options$ = this.getDays$().pipe(
      map(
        dates => dates.map(
          dt => ({ Value: format(dt, 'yyyy-MM-dd'), Label: format(dt, 'EEEE d MMMM yy') })
        )
      )
    );
  }

  private getDays$() {
    let startDate = startOfToday();
    if (this.question.options.StartOffset)
      startDate = addDays(startDate, this.question.options.StartOffset);

    if (this.question.options.WorkingDays)
      return this.dateService.getWorkDays$(startDate, this.question.options.Days ?? 14);

    return of(this.dateService.getDays(startDate, this.question.options.Days));
  }

  onChange() {
    this.question.setAnswer(this.question.editingValue, true);
  }
}

type Options = { Value: string, Label: string };

